import React from 'react';
import FormulaireInscriptionEnLigne from './global-components/formulaire-inscritenligne';
const InscriptionEnLigne = () => {
  return (
    <div>
      <FormulaireInscriptionEnLigne />
    </div>
  );
};
export default InscriptionEnLigne;
